// Centralised date math for delivery countdown logic.
// All comparisons use LOCAL midnight to avoid timezone drift.

export function parseDateOnly(iso) {
  // iso = "YYYY-MM-DD" or full ISO datetime; treat as LOCAL date
  if (!iso) return null;
  const ymd = iso.slice(0, 10).split("-");
  if (ymd.length !== 3) return null;
  const [y, m, d] = ymd.map((v) => parseInt(v, 10));
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d, 0, 0, 0, 0);
}

export function todayLocal() {
  const n = new Date();
  return new Date(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0, 0, 0);
}

export function daysUntil(iso) {
  const target = parseDateOnly(iso);
  if (!target) return null;
  const today = todayLocal();
  const ms = target - today;
  return Math.round(ms / (1000 * 60 * 60 * 24));
}

// Returns an object describing the urgency bucket for an order/task delivery
// Buckets aligned with new alert policy:
//  - overdue : Red
//  - today   : Red
//  - tomorrow (1 day) : Orange
//  - two_days (2 days) : Yellow
//  - future (>2 days) : Gray
//  - none : no date
export function urgencyOf(iso) {
  const days = daysUntil(iso);
  if (days === null) return { bucket: "none", days: null };
  if (days < 0) return { bucket: "overdue", days: Math.abs(days) };
  if (days === 0) return { bucket: "today", days: 0 };
  if (days === 1) return { bucket: "tomorrow", days: 1 };
  if (days === 2) return { bucket: "two_days", days: 2 };
  return { bucket: "future", days };
}

export function formatDate(iso, lang = "es") {
  const d = parseDateOnly(iso);
  if (!d) return "";
  const locale = lang === "en" ? "en-US" : "es-ES";
  return d.toLocaleDateString(locale, { day: "2-digit", month: "short", year: "numeric" });
}

export function formatDateTime(iso, lang = "es") {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const locale = lang === "en" ? "en-US" : "es-ES";
  return d.toLocaleString(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

